export const validateNullOrEmpty = (object) => {
  return Object.values(object).some(
    (item) => item === "" || item === null || item === undefined
  );
};


export const increaseTime = (time, hours) => {
  return new Date(time.getTime() + hours * 60 * 60 * 1000);
};
export const decreaseTime = (time, hours) => {
  return new Date(time.getTime() + hours * 60 * 60 * 1000);
};
